import axios from "axios";
import { useEffect, useState } from "react";
import Logo from "../../components/logo/logo.components";
import clientConfig from "../../env";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { AiOutlineHome } from "react-icons/ai";

const styles = {
    approveEventContainer : {
        minHeight: "100vh",
        backgroundColor: "#212529",
        color: "#ffffff"
    }
}

const ApproveEvent = () => {

  const [message, setMessage] = useState("")
  const [topicName, setTopicName] = useState("");
  const approveEvent = async (values) => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/approve-event`,
        values,
        { headers: headers }
      );
      
      console.log(response);
      if (response.status === 200) {
        setMessage(response.data.message);
      } else {
        setMessage("Something went wrong, Please contact support team.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params.ev) {
      const values = JSON.parse(window.atob(params.ev));
      approveEvent(values);
      setTopicName(values.topic_name);
      console.log({ values });
    }
  }, []);

  return (
    <>
      <div style={styles.approveEventContainer} className="py-3  py-md-5">
        <div className="py-4 text-center">
          <Logo />
        </div>
        <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="h2 mb-4 mt-5">Event Topic : {topicName}</h2>
                <p className="lead w-100 text-center">{message}</p>

                <Link
                  to={"/"}
                  className="btn btn-primary px-4 mt-4 rounded-0 border-0 align-items-center"
                  style={{ paddingTop: 12, paddingBottom: 12 }}
                >
                  <AiOutlineHome
                    className="white-txt"
                    size="1.5em"
                    style={{ marginRight: 8 }}
                  />{" "}
                  Return to Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApproveEvent;
